import { Link } from 'react-router-dom';

/**
 * Dashboard's building block. Unlike apps/ops's StatCard, there is no
 * 403-hiding logic here - a portal session either sees a number (its own
 * scoped count, computed server-side) or an error; there is no role that
 * could plausibly lack access to its own dashboard.
 */
export function StatCard({ label, value, href }: { label: string; value: number | string; href?: string }): JSX.Element {
  const content = (
    <>
      <div className="n">{value}</div>
      <div className="label">{label}</div>
    </>
  );
  if (href) {
    return (
      <Link to={href} className={`stat-card ${value === 0 ? 'n-zero' : ''}`}>
        {content}
      </Link>
    );
  }
  return <div className={`stat-card ${value === 0 ? 'n-zero' : ''}`}>{content}</div>;
}
